


import { mapMutations} from 'vuex';
import { MODAL } from '@/enum/global';

console.log("window._paq",window._paq)

//matomo設定
export const mixinMatomo = {
  mounted(){
  },
  methods:{
    matomoSetUserId(userId){  //設置userID
      console.log("window._paq",window._paq)
        if(window._paq === undefined) return;
        let paq = window._paq;
        paq.push(['setUserId', userId]);
    },
    matomoConsentHandle(isAgreeTracking){ //徵得同意
        if(window._paq === undefined) return;
        let paq = window._paq;
        const _isAgreeTracking = isAgreeTracking;
        if(_isAgreeTracking){
            // user has given consent to process their data
            paq.push(['setConsentGiven']);
            // OR user has given consent to store and use cookies
            paq.push(['setCookieConsentGiven']);
            paq.push(['trackPageView']);
        }
        console.log('window',window);  
    },
 }
}  



export const modalConfigMix = {
  data(){
  },
  methods: {
    ...mapMutations({
      setModal: 'modal/setShowModal',
      setModalType: 'modal/setType',  // show modal
    }),
    closeModal(e = false){ //外面呼叫
      this.setModal(e) 
      this.setModalType({})
      // console.log(this.$store.state.modal.isShow, this.$store.state.modal.modalType)
    },
    classification(modalType){
      // console.log(modalType,'0000')
      let type = {}
      switch (modalType) {
        case MODAL[400]: 
          type = {
            data:{
              title: this.$t('__popUpRelated.__unexpectedError'),
              content: this.$t('__popUpRelated.__sorryWeVeEncounteredAnErrorPleaseTryAgainLater', { errorCode: 'I01' }),
              pic:'Alert',
            },
            btnConfirm:{
              isShow: false,
            },
            btnClose: {
                isShow: true,
                text: this.$t('__globeButton.__close'),
                icon:'',
                onClose: ()=> {
                  console.log('onclose')
                  this.closeModal()
                  // this.$router.push({path: '/'}).catch(err => err);
                }
            },
            fontSize: '14',
            
            // align: 
          }
          break;
        case MODAL[405]: 
          type = {
            data:{
              title: this.$t('__popUpRelated.__unexpectedError'),
              content: this.$t('__popUpRelated.__sorryWeVeEncounteredAnErrorPleaseTryAgainLater', { errorCode: 'I03' }),
              pic:'Alert',
            },
            btnConfirm:{
              isShow: false,
            },
            btnClose: {
                isShow: true,
                text: this.$t('__globeButton.__close'),
                icon:'',
                onClose: ()=> {
                  console.log('onclose')
                  this.closeModal()
                }
            },
            fontSize: '14',
            
            // align: 
          }
          break;
        case MODAL[404]: 
            type = {
              data:{
                // title: 'Oops                ',
                // content: 'The Page is not exist. We will back to the index Page.',
                title: this.$t('__popUpRelated.__unexpectedError'),
              content: this.$t('__popUpRelated.__sorryWeVeEncounteredAnErrorPleaseTryAgainLater', { errorCode: 'I04' }),
                pic:'Alert',
              },
              btnConfirm:{
                isShow: false,
              },
              btnClose: {
                  isShow: true,
                  text: this.$t('__globeButton.__close'),
                  icon:'',
                  onClose: ()=> {
                    console.log('onclose')
                    this.closeModal()
                    // this.$router.push({path: '/'}).catch(err => err);
                  }
              },
              fontSize: '14',
              
              // align: 
            }
          break;

        case MODAL[500]:
          type = {
            data:{
              // title: 'Server No Response',
              // content: 'Please contact your FAE and we will fix it as soon as possible.Error Code: E05',
              title: this.$t('__popUpRelated.__unexpectedError'),
              content: this.$t('__popUpRelated.__sorryWeVeEncounteredAnErrorPleaseTryAgainLater', { errorCode: 'I02' }),
              pic:'Default',
            },
            btnConfirm:{
              isShow: false,
            },
            btnClose: {
                isShow: true,
                text: this.$t('__globeButton.__close'),
                icon:'',
                onClose: ()=> {
                  console.log('onclose')
                  this.closeModal()
                }
            },
            fontSize: '14',
            // align: 

          }
          break;
        case MODAL[502]:
          type = {
            data:{
              title: this.$t('__popUpRelated.__requestTimeout'),
              content: this.$t('__popUpRelated.__requestTimeoutPleaseRefreshThePage'),
              pic:'Default',
            },
            btnConfirm:{
              isShow: false,
            },
            btnClose: {
                isShow: true,
                text: this.$t('__globeButton.__gotIt'),
                icon:'',
                onClose: ()=> {
                  console.log('onclose')
                  this.closeModal()
                }
            },
            fontSize: '14',
            // align: 

          }
          break;
        case MODAL['download403']:
          type = {
            data:{
              title: this.$t('__popUpRelated.__notice'),
              content: this.$t('__popUpRelated.__sorryYourDownloadLinkIsBroken'),
              pic:'Default',
            },
            btnConfirm:{
              isShow: false,
            },
            btnClose: {
                isShow: true,
                text: this.$t('__globeButton.__close'),
                icon:'',
                onClose: ()=> {
                  console.log('onclose')
                  this.closeModal()
                }
            },
            fontSize: '14',
            // align: 

          }
          break;
        case MODAL['download404']:
          type = {
            data:{
              title: this.$t('__popUpRelated.__unexpectedError'),
              content:this.$t('__popUpRelated.__sorryWeVeEncounteredAnErrorPleaseTryAgainLater', { errorCode: 'D01' }),
              pic:'Default',
            },
            btnConfirm:{
              isShow: false,
            },
            btnClose: {
                isShow: true,
                text: this.$t('__globeButton.__close'),
                icon:'',
                onClose: ()=> {
                  console.log('onclose')
                  this.closeModal()
                }
            },
            fontSize: '14',
            // align: 

          }
          break;
        case 503:
            //重整以顯示系統維護頁面
            
          break;
        case 'offline':
          type = {
            data:{
              title: this.$t('__popUpRelated.__requestTimeout'),
              content: this.$t('__popUpRelated.__requestTimeoutPleaseRefreshThePage'),
              pic:'Default',
            },
            btnConfirm:{
              isShow: false,
            },
            btnClose: {
                isShow: true,
                text: this.$t('__globeButton.__gotIt'),
                icon:'',
                onClose: ()=> {
                  console.log('onclose')
                  this.closeModal()
                }
            },
            fontSize: '14',
            // align: 

          }
            break;
        
    
        default:
          break;
      }
      return type
    },


  } 
} 


export const globalFixed = {
  data(){
    return {
    };
  },
  mounted(){
  },
  methods: {
      isFixed(n, className = 'fixed', takePlace = false) {
          if (n) {
            // console.log(takePlace)
            document.body.style.top = `-${window.pageYOffset}px`;
            if(takePlace){
              if(document.body.scrollHeight > window.innerHeight){
                document.body.classList.add('fixedPlace');
              }
              
            }else{
              document.body.classList.add('fixed');
            }
            // console.log( document.body.scrollHeight > document.body.clientHeight)
          }
          else {
            document.body.classList.remove('fixed');
            document.body.classList.remove('fixedPlace');
            // console.log(window.pageYOffset,document.body.style.top)
            const scrollY = document.body.style.top;
            document.body.style.top = '';
            window.scrollTo(0, parseInt(scrollY || '0') * -1);
          }
      } //end: isFixedBody
  }
}
